var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 3.75H16.2499V1.25H14.9999V3.75H12.4999V5H14.9999V7.5H16.2499V5H18.7499V3.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 17.8662L11.2655 14.1318C12.1656 13.0057 12.6003 11.5778 12.4804 10.1413C12.3605 8.70472 11.695 7.36862 10.6207 6.40743C9.54639 5.44624 8.14478 4.93293 6.70379 4.97295C5.2628 5.01296 3.89184 5.60326 2.87251 6.62258C1.85319 7.64191 1.26289 9.01287 1.22288 10.4539C1.18287 11.8948 1.69617 13.2965 2.65736 14.3708C3.61855 15.4451 4.95465 16.1106 6.3912 16.2305C7.82774 16.3504 9.25568 15.9157 10.3817 15.0156L14.1161 18.75L14.9999 17.8662ZM2.49993 10.625C2.49993 9.75971 2.75652 8.91385 3.23725 8.19438C3.71798 7.47492 4.40126 6.91416 5.20069 6.58303C6.00012 6.25189 6.87978 6.16525 7.72845 6.33406C8.57712 6.50287 9.35667 6.91955 9.96852 7.53141C10.5804 8.14326 10.9971 8.92281 11.1659 9.77148C11.3347 10.6201 11.248 11.4998 10.9169 12.2992C10.5858 13.0987 10.025 13.7819 9.30555 14.2627C8.58609 14.7434 7.74022 15 6.87493 15C5.715 14.9987 4.60296 14.5374 3.78276 13.7172C2.96257 12.897 2.50122 11.7849 2.49993 10.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.afca83ad9caf477a2209328897e4dd70.svg";
export { ForwardRef as ReactComponent };